import React from "react";

import "./styles.css";

/**
 * Cabeçalho de coluna ordenável PADRÃO (PO1-2724), extraído da Auditoria de
 * Faturas. Botão sem borda com o rótulo e o indicador ↑ ↓ ↕; o indicador ativo
 * usa a cor de destaque.
 *
 * Props: label, field, sort ({ field, dir: "asc" | "desc" }), onSort(field),
 *        align ("left" | "right" | "center"), className.
 * Use `toggleSort` de utils/tableHelpers para alternar a direção.
 */
export default function SortHeader({ label, field, sort, onSort, align = "left", className = "" }) {
  const active = Boolean(sort) && sort.field === field;
  const indicator = active ? (sort.dir === "asc" ? "↑" : "↓") : "↕";
  const alignClass =
    align === "right" ? " hub-sort--right" : align === "center" ? " hub-sort--center" : "";

  return (
    <button
      type="button"
      className={`hub-sort${alignClass} ${className}`.trim()}
      onClick={() => (onSort ? onSort(field) : undefined)}
      aria-pressed={active}
      title={active ? (sort.dir === "asc" ? "Ordenado crescente" : "Ordenado decrescente") : "Ordenar"}
    >
      <span>{label}</span>
      <span className={`hub-sort__icon${active ? " is-active" : ""}`} aria-hidden="true">
        {indicator}
      </span>
    </button>
  );
}
